import { useState } from "react";
import { Fab, Tooltip } from "@mui/material";
import { Fullscreen, FullscreenExit } from "@mui/icons-material";
import { useMap } from "react-leaflet";
import { ControlOptions } from "leaflet";
import { useTranslation } from "react-i18next";

import { FullScreenGuard } from "../guards/FullScreenGuard";
import { MapControlBase } from "./MapControlBase";

interface Props extends ControlOptions {
  config: string;
}

export function FullscreenControl(props: Props) {
  const { config, ...controlProps } = props;
  const map = useMap();
  const mapContainer = map.getContainer();
  const { t } = useTranslation();
  const [fullscreenState, setFullscreenState] = useState<boolean>(false);

  const onToggleFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      mapContainer.requestFullscreen();
    }
  };

  return (
    <MapControlBase {...controlProps}>
      <Tooltip
        title={
          fullscreenState
            ? t<string>("label.exitFullscreenMode")
            : t<string>("label.enterFullscreenMode")
        }
        PopperProps={{
          disablePortal: true,
        }}
        placement="left"
      >
        <Fab size="small" variant="circular" onClick={onToggleFullscreen}>
          {!fullscreenState && <Fullscreen />}
          {fullscreenState && <FullscreenExit />}
        </Fab>
      </Tooltip>
      <FullScreenGuard onToggle={() => setFullscreenState((prev) => !prev)} />
    </MapControlBase>
  );
}
